import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { exportCsv } from "@/lib/csv";
import { Download } from "lucide-react";

export default function Unallocated() {
  const { t } = useLang();
  const [items, setItems] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [sel, setSel] = useState({});
  const load = () => api.get("/client-orders", { params: { unallocated: true } }).then((r) => setItems(r.data));
  useEffect(() => {
    load();
    api.get("/vendors").then((r) => setVendors(r.data));
  }, []);
  const allocate = async (id) => {
    if (!sel[id]) return;
    await api.patch(`/client-orders/${id}`, { vendor_id: sel[id] });
    load();
  };
  const doExport = () => {
    exportCsv(
      items,
      [
        { key: "client_po_number", label: "Client PO" },
        { key: "sku", label: "SKU" },
        { key: "sku_description", label: "Description" },
        { key: "collection", label: "Collection" },
        { key: "colour_attribute", label: "Colour" },
        { key: "outstanding_qty", label: "Outstanding Qty" },
        { key: "earliest_ship_date", label: "Earliest Ship", format: (v) => (v ? new Date(v).toLocaleDateString() : "") },
        { key: "latest_ship_date", label: "Latest Ship", format: (v) => (v ? new Date(v).toLocaleDateString() : "") },
        { key: "vendor_name", label: "Vendor" },
        { key: "urgency", label: "Urgency" },
      ],
      "unallocated_client_orders.csv"
    );
  };
  return (
    <div>
      <div className="eyebrow">{t("nav_unallocated")}</div>
      <div className="flex items-center justify-between flex-wrap gap-2">
        <h1 className="text-2xl font-bold" style={{ color: "var(--brand-navy)" }}>Vendor Not Yet Allocated</h1>
        <button data-testid="unalloc-export-btn" onClick={doExport} className="h-10 px-3 rounded-md border border-[#1B3A5C]/15 text-sm flex items-center gap-1">
          <Download size={14} /> {t("export_csv")}
        </button>
      </div>
      <div className="text-sm text-[#4A627A] mt-1" data-testid="unallocated-count">{items.length} client order lines</div>
      <div className="overflow-x-auto hag-scroll mt-4">
        <table className="w-full text-sm hag-surface">
          <thead className="bg-[#FAF6F0] text-[#4A627A] uppercase text-xs tracking-widest">
            <tr><th className="p-3 text-left">Client PO</th><th className="p-3 text-left">SKU</th><th className="p-3 text-left">Collection</th><th className="p-3 text-left">Latest ship</th><th className="p-3 text-left">Vendor</th><th></th></tr>
          </thead>
          <tbody>
            {items.map((c) => (
              <tr key={c.id} data-testid={`unalloc-${c.id}`} className="border-t border-[#1B3A5C]/5">
                <td className="p-3 font-semibold">{c.client_po_number}</td>
                <td className="p-3">{c.sku}</td>
                <td className="p-3">{c.collection}</td>
                <td className="p-3">{c.latest_ship_date ? new Date(c.latest_ship_date).toLocaleDateString() : "—"}</td>
                <td className="p-3">
                  <select data-testid={`vendor-sel-${c.id}`} value={sel[c.id] || ""} onChange={(e) => setSel({ ...sel, [c.id]: e.target.value })} className="h-10 border border-[#1B3A5C]/15 rounded-md px-2">
                    <option value="">— select —</option>
                    {vendors.map((v) => <option key={v.id} value={v.id}>{v.name}</option>)}
                  </select>
                </td>
                <td className="p-3">
                  <button data-testid={`alloc-btn-${c.id}`} onClick={() => allocate(c.id)} className="h-10 px-3 rounded-md text-sm text-white" style={{ background: "var(--brand-navy)" }}>Allocate</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
